import ClickToOpen from "./click-to-open.js";
import { l as layout } from "./layout-store.js";
import { c as calculateMilliseconds } from "./utilities.js";
import { E } from "./preact-signals.js";
import "./lodash-utils.js";
class CustomModal extends ClickToOpen {
  constructor() {
    super();
    this.type = null;
    this.paramsOpened = false;
    this.isOpen = true;
    this.typeClasses = [];
    this.layout = layout;
    this.modalEl = this.querySelector(".modal");
    this.closeEl = this.querySelector(".close");
    this.timeout = this.dataset.timeout && typeof Number(this.dataset.timeout) === "number" ? calculateMilliseconds(Number(this.dataset.timeout)) : calculateMilliseconds(24);
    if (!this.modalEl) {
      console.error("Modal couldn't find modal element");
      console.log(this);
      return;
    }
    if (this.id === void 0 || this.id == null) {
      console.error("Modal needs id value");
      console.log(this);
      return;
    }
    this.type = this.dataset.type;
    if (this.type) {
      this.typeClasses.push(`modal--${this.type}`);
    }
    this.typeClasses.forEach((cl) => {
      this.modalEl.classList.add(cl);
    });
    this.dialogEl = this.querySelector(".modal__panel");
    this.initDialog();
    if (this.dataset.cookie) {
      this.checkCookie();
      this.addEventListener("close", () => {
        this.setCookie();
      });
    }
    E(() => {
      if (this.layout.modal.value == this.id) {
        this.isOpen = true;
        document.body.classList.add("modal-open");
        this.modalEl.classList.add("active");
      } else {
        this.isOpen = false;
        document.body.classList.remove("modal-open");
        this.modalEl.classList.remove("active");
      }
      document.documentElement.style.overflow = this.isOpen ? "hidden" : "";
      this.syncDialogState(Boolean(this.isOpen));
    });
  }
  setCookie() {
    const timestamp = Date.now();
    const storage = window.localStorage;
    storage.setItem(this.dataset.cookie, timestamp.toString());
  }
  checkCookie() {
    const storage = window.localStorage;
    const originalCookie = storage.getItem(this.dataset.cookie);
    const now = Date.now();
    if (!originalCookie || Number(originalCookie) + this.timeout <= now) {
      this.open();
    }
  }
  open() {
    this.layout.modal.value = this.id;
    this.dispatchEvent(new Event("open", { bubbles: true, composed: true }));
  }
  close() {
    this.layout.modal.value = null;
    if (this.dataset.cookie) {
      this.setCookie();
    }
    this.dispatchEvent(new Event("close", { bubbles: true, composed: true }));
  }
}
if (!customElements.get("custom-modal")) {
  customElements.define("custom-modal", CustomModal);
}
export {
  CustomModal,
  CustomModal as default
};
